<div class="fund-request card">
    <card i18n-headerTitle headerTitle="Requested Funds" [hasFooter]="true">
        <div card-body class="card-body">
            <lsq-icon
                *ngIf="!!tooltipText"
                [attr.tabindex]="0"
                [type]="icons.QuestionCircleLight"
                [popoverOnHover]="true"
                [height]="14"
                [width]="14"
                [popover]="tooltipText"
                [popoverPlacement]="tooltipPlacement"
                [color]="color.Slate"
            >
            </lsq-icon>
            <no-data-box [titleText]="noDataTitle" *ngIf="data?.length == 0"> </no-data-box>
            <div class="row" *ngIf="data?.length != 0">
                <div class="col">
                    <lsq-data-table-mobile
                        *ngIf="isSmBelow$ | async"
                        [dataSource]="getReserveReleasesDataSource"
                        [borderlessCards]="false"
                    >
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="mtc-header-wrapper">
                                <div class="mtc-header-content-left">
                                    <div class="mtc-header-title">
                                        {{ row.amountRequested | currencyDash }}
                                    </div>
                                    <div class="mtc-header-sub-title">
                                        <span>{{
                                            getFormattedDateTimeForMobile(row.dateRequested)
                                        }}</span>
                                    </div>
                                </div>
                                <div class="mtc-header-content-right">
                                    <ng-container *ngIf="!!row.reserveReleaseStatus">
                                        <div class="mtc-header-status-text">
                                            <status-pill
                                                [status]="'statusText'"
                                                [displayValueMap]="
                                                    getInfoForStatus(row.reserveReleaseStatus)
                                                "
                                                [color]="
                                                    getInfoForStatus(row.reserveReleaseStatus).color
                                                "
                                            ></status-pill>
                                            <lsq-icon-popover
                                                *ngIf="!(isSmBelow$ | async)"
                                                [text]="
                                                    getInfoForStatus(row.reserveReleaseStatus)
                                                        .tooltip
                                                "
                                            >
                                            </lsq-icon-popover>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-template>

                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ submissionDateHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ getFormattedDateTimeForMobile(row.dateRequested) }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ dateProcessedMobileHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ getFormattedDateTimeForMobile(row.dateProcessed) }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ amountRequestedMobileHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.amountRequested | currencyDash }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ amountFundedMobileHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.amountFunded | currencyDash }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>

                    <lsq-data-table
                        *ngIf="!(isSmBelow$ | async)"
                        [dataSource]="getReserveReleasesDataSource"
                        [layoutFixed]="true"
                    >
                        <ng-template #noDataContent>
                            <no-data-box [titleText]="noDataTitle"> </no-data-box>
                        </ng-template>
                        <lsq-column
                            [column]="{
                                key: 'dateRequested',
                                header: dateRequestedHeader,
                                mobileHeader: 'Submission Date',
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <a
                                    class="light-font"
                                    [popover]="row.dateRequested"
                                    [routerLink]="routerLinkRequestFunds"
                                >
                                    {{ getFormattedDateTimeForMobile(row.dateRequested) }}
                                </a>
                            </ng-template>
                        </lsq-column>

                        <lsq-date-column
                            [column]="{
                                key: 'dateProcessed',
                                header: dateProcessedHeader,
                                sortable: false
                            }"
                        >
                        </lsq-date-column>

                        <lsq-currency-column
                            [column]="{
                                key: 'amountRequested',
                                header: amountRequestedHeader,
                                sortable: false
                            }"
                        ></lsq-currency-column>

                        <lsq-currency-column
                            [column]="{
                                key: 'amountFunded',
                                header: amountFundedHeader,
                                sortable: false
                            }"
                        ></lsq-currency-column>

                        <lsq-column
                            [column]="{
                                key: 'reserveReleaseStatus',
                                header: statusHeader,
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <ng-container *ngIf="!!row.reserveReleaseStatus">
                                    <status-pill
                                        [status]="'statusText'"
                                        [displayValueMap]="
                                            getInfoForStatus(row.reserveReleaseStatus)
                                        "
                                        [color]="getInfoForStatus(row.reserveReleaseStatus).color"
                                        popover="{{
                                            getInfoForStatus(row.reserveReleaseStatus).tooltip
                                        }}"
                                    ></status-pill>
                                </ng-container>
                            </ng-template>
                        </lsq-column>
                    </lsq-data-table>
                </div>
            </div>
        </div>
        <div card-footer>
            <div class="footer-container">
                <a i18n [routerLink]="routerLinkRequestFunds">View Requested Funds</a>
                <a i18n [routerLink]="routerLinkAllFundings">View All Fundings</a>
            </div>
        </div>
    </card>
</div>
